// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import axios from './utils/axios'
import VideoPlayer from 'vue-video-player'
import store from './store'
import pubsub from 'pubsub-js'
import { Toast } from 'vant'
import 'vant/lib/toast/style'
// import $ from 'jquery'

// window.$ = $
// window.jQuery = $
Vue.config.productionTip = false
Vue.prototype.$pubsub = pubsub
Vue.prototype.$toast = Toast
Vue.prototype.$axios = axios

require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
Vue.use(ElementUI)
Vue.use(VideoPlayer)

// eslint-disable-next-line no-new
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js